export { AccessErrorPlaceholderIcon } from './assets';
